import React from 'react';
import { EmptyState } from '../feedback';
import PublicadorCard from './PublicadorCard';

const PublicadoresList = ({
  publicadores,
  ultimasDesignacoes,
  limitesFrequencia,
  disponibilidadeSemana,
  ausenciasSelecionadas,
  selecionados,
  togglePublicador,
}) => {
  if (publicadores.length === 0) {
    return <EmptyState message="Nenhum publicador encontrado" />;
  }

  return (
    <>
      {publicadores.map((publicadorData) => {
        const usuarioId = publicadorData?.usuario?._id;
        const isSelected = selecionados.some((p) => p._id === usuarioId);
        const maxSelected = selecionados.length >= 3;
        const selectedIndex = selecionados.findIndex((p) => p._id === usuarioId);

        return (
          <PublicadorCard
            key={usuarioId}
            publicadorData={publicadorData}
            ultimaDesignacao={ultimasDesignacoes[usuarioId]}
            limite={limitesFrequencia[usuarioId]}
            dispSemana={disponibilidadeSemana[usuarioId]}
            ausenciaAtiva={ausenciasSelecionadas[usuarioId]}
            isSelected={isSelected}
            isDisabledByMax={!isSelected && maxSelected}
            totalSelecionados={selecionados.length}
            togglePublicador={togglePublicador}
          />
        );
      })}
    </>
  );
};

export default PublicadoresList;
